var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubtract(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.911 7.527a.502.502 0 00-.438.422.504.504 0 00.407.567c.043.008 1.14.009 7.146.007 6.744-.001 7.096-.002 7.132-.013.17-.05.31-.186.355-.35a.504.504 0 00-.356-.623l-.05-.014H8.035c-3.89 0-7.095.001-7.124.004z",
    fill: "currentColor"
  })));
}
export default SvgSubtract;